import React from 'react';
import { Link, Outlet, useNavigate, useLocation } from 'react-router-dom';
import api from '../../services';

const Layout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const isTelescope = location.pathname === '/backoffice/telescope';

    const handleLogout = async () => {
        await api('logout', {}, 'POST');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/backoffice/login');
    };

    return (
        <div style={{ display: 'flex', height: '100vh' }}>
            {/* Sidebar */}
            <div style={{ width: '250px', flexShrink: 0, background: '#001529', color: 'white', padding: '20px', boxSizing: 'border-box' }}>
                <h2 style={{ color: 'white', textAlign: 'center' }}>Certage Admin</h2>
                <nav style={{ marginTop: '40px' }}>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        <li style={{ marginBottom: '16px' }}>
                            <Link to="/backoffice" style={{ color: 'white', textDecoration: 'none' }}>Dashboard</Link>
                        </li>
                        <li style={{ marginBottom: '16px' }}>
                            <Link to="/backoffice/clients" style={{ color: 'white', textDecoration: 'none' }}>Clients</Link>
                        </li>
                        {process.env.REACT_APP_TELESCOPE_URL && (
                            <li style={{ marginBottom: '16px' }}>
                                <Link to="/backoffice/telescope" style={{ color: 'white', textDecoration: 'none' }}>Telescope</Link>
                            </li>
                        )}
                    </ul>
                </nav>
            </div>

            {/* Main Content */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: '#f0f2f5', minWidth: 0 }}>
                {/* Header */}
                <header style={{ background: 'white', padding: '0 24px', height: '64px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' }}>
                    <span style={{ marginRight: '16px' }}>{user.name}</span>
                    <button onClick={handleLogout} style={{ padding: '6px 16px', borderRadius: '4px', border: '1px solid #d9d9d9', background: 'white', cursor: 'pointer' }}>
                        Logout
                    </button>
                </header>

                {/* Content Area */}
                <main style={{ padding: isTelescope ? '0' : '24px', flex: 1, overflow: 'auto' }}>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Layout;
